import './bootstrap';

import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

// Note: Exposed routes are filtered in config/ziggy.php.
const appName = import.meta.env.VITE_APP_NAME || '';

createInertiaApp({
	title: (title) => `${title}`,
	resolve: name => window.location.hostname === import.meta.env.VITE_DOMAIN_16100
		? resolvePageComponent(`./Fi16100/Pages/${name}.jsx`, import.meta.glob('./Fi16100/Pages/**/*.jsx'))
		: resolvePageComponent(`./Phonebook/Pages/${name}.jsx`, import.meta.glob('./Phonebook/Pages/**/*.jsx')),
	setup({ el, App, props }) {
		const root = createRoot(el);

		root.render(<App {...props} />);
	},
	progress: {
		color: '#082886',
	},
});
